<template>
  <div class="data-list-container">
    <vs-card class="cstm_vx_card">
      <div slot="header">
        <h4>Filter Module </h4>
      </div>

    <vs-table class="cstm_vuexy_table" :data="custom_fields">
      <template slot="thead">
        <vs-th style="width: 100px;">Sl No.</vs-th>
        <vs-th>Icon</vs-th>
        <vs-th>Module</vs-th>
        <vs-th style="width: 220px;">Customize Dynamic Filter</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{ indextr + 1 }}</vs-td>
          <vs-td :data="data[indextr].name" class="icon_td">
            <!-- <span class="feather icon-phone-call" color="blue"></span> -->
            <span class="material-icons-outlined" v-if="data[indextr].name == 'Leads' || data[indextr].name == 'CRM'">contacts</span>
            <span class="material-icons-outlined" v-if="data[indextr].name == 'Client' || data[indextr].name == 'Students'">supervised_user_circle</span>
            <span class="material-icons-outlined" v-if="data[indextr].name == 'Staff' || data[indextr].name == 'Staff'">badge</span>
          </vs-td>

          <vs-td :data="data[indextr].name">
          <span v-if="data[indextr].name=='Client' || data[indextr].name == 'Students'">
           Student
          </span>
          <span v-else-if="data[indextr].name=='Leads' || data[indextr].name == 'CRM'">
            CRM
          </span>
          <span v-else>
            {{data[indextr].name}}
          </span>
         
        </vs-td>

          <vs-td :data="data[indextr].id">
              <vs-button
                class="m-auto"
                icon="settings"
                :to="{ name:'filter-list-module1',                
                  params:{'modelname': data[indextr].path}                
                }"
              >
              </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    </vs-card>
  </div>
</template>
<script>

export default {
  name: 'FilterSettings',

  data () {
    return {
      custom_fields: [
        {
          name: 'Leads',
          path: 'Leads'
        },
        {
          name: 'Staff',
          path: 'Staff'
        },
        {
          name: 'Client',
          path: 'Accounts'
        }
      ]
    }
  }
}
</script>

<style>
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
</style>